import { createFileRoute } from '@tanstack/react-router';
import { Helmet } from 'react-helmet-async';
import { AgencyMetaAdsPage, type AgencyMetaAdsOAuthParams } from '@/features/agency';
import { formatDocumentTitle } from '@/lib/document-title';

const readParam = (value: unknown): string | undefined =>
  typeof value === 'string' && value.length > 0 ? value : undefined;

/**
 * Every agency member may use it (the parent layout gates non-agency users; the API scopes salons). Also the
 * Facebook Login redirect target for "Connect Meta Ads": must match the API's `META_ADS_OAUTH_REDIRECT_URL`
 * exactly and be listed in the Meta app's "Valid OAuth Redirect URIs".
 */
export const Route = createFileRoute('/_auth/agency/meta-ads')({
  validateSearch: (search: Record<string, unknown>): AgencyMetaAdsOAuthParams => ({
    code: readParam(search.code),
    state: readParam(search.state),
    error: readParam(search.error),
  }),
  component: AgencyMetaAdsRoute,
});

function AgencyMetaAdsRoute() {
  const oauth = Route.useSearch();
  return (
    <>
      <Helmet defer={false}>
        <title>{formatDocumentTitle('Meta Ads')}</title>
      </Helmet>
      <AgencyMetaAdsPage oauth={oauth} />
    </>
  );
}
